/* eslint-disable */
import { Typography } from '@material-ui/core';
import React from 'react';
import PageLargeTopBar from '../Layouts/PageLargeTopBar';
import LayoutTemplate3PagePropTypes from './LayoutTemplate3.page.props';

/**
 * LayoutTemplate3PageComponent
 * @export
 * @class LayoutTemplate3PageComponent
 * @extends {React.Component<LayoutTemplate3PageComponentComposedProps, LayoutTemplate3PageComponentState>}
 */
export class LayoutTemplate3PageComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. **NOT** a `null` value
   * @static
   * @type {Partial<LayoutTemplate3PageComponentProps>}
   * @memberof LayoutTemplate3PageComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`LayoutTemplate3Page`}
   * @memberof LayoutTemplate3PageComponent
   */
  static displayName = `LayoutTemplate3Page`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof LayoutTemplate3PageComponent
   */
  static propTypes = LayoutTemplate3PagePropTypes;

  /**
   * Data specific to the `<LayoutTemplate3Page />` instance
   * @type {LayoutTemplate3PageComponentState}
   * @memberof LayoutTemplate3PageComponent
   */
  state = {};

  /**
   * Render the layoutTemplate3
   * @returns {React.Component} The rendered layoutTemplate3
   * @memberof LayoutTemplate3PageComponent
   */
  exampleComponent = () => (
    <div style={{ backgroundColor: `#ffb9ec`, height: `2000px` }}>
      Any component can go in this space e.g. 4 columns dashboard with cards, or single column T&amp;C's. For now its just tall box with lots of pink.
    </div>
  );

  /**
   * Render the layoutTemplate3
   * @returns {React.Component} The rendered layoutTemplate3
   * @memberof LayoutTemplate3PageComponent
   */
  exampleComponent2 = () => <Typography variant="h5">Page Title</Typography>;

  /**
   * Render the component
   * @returns {React.Component} The rendered `<LayoutTemplate3Page />`
   * @memberof LayoutTemplate3PageComponent
   */
  render() {
    return (
      <PageLargeTopBar
        largeNavBar={this.exampleComponent2()} // top bar content
        title="LayoutTemplate3Page.PageTitle"
      >
        {this.exampleComponent()}
      </PageLargeTopBar>
    );
  }
}

export default LayoutTemplate3PageComponent;
